import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PrivacyTipIcon(props: IconProps) {
    return <Icon {...props} iconKey={"privacy_tip"}/>
}
